import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
import { uploadEvent } from '@/api/goods/statistics';
let default_1 = class extends Vue {
    constructor() {
        super(...arguments);
        this.ios10Shadow = false;
        this.recordList = [];
        //当前查看类型
        this.type = 1;
        this.isloading = true;
        //累计
        this.total_count = 0;
        this.firstList = [];
        this.secondList = [];
        this.showIntro = false;
        this.memId = 0;
    }
    get noclaimtip() {
        if (this.type == 2) {
            return '暂无消费记录';
        }
        else if (this.type == 1) {
            return '暂无认领记录';
        }
        return '';
    }
    refund_statustxt(txt) {
        if (txt == 1) {
            return '部分退款';
        }
        else if (txt == 2) {
            return '全部退款';
        }
        return '';
    }
    async mounted() {
        await env.init();
        if (env.type === 'web')
            return this.$Toast('请在App或微信中打开');
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            return await env.login();
        }
        await this.setData();
        this.isloading = false;
        this.onClickTab(1);
        this.getResult();
        uploadEvent.init();
        let info = await env.getInfo();
        this.memId = env.type === 'wx' ? info.logined.user.id : info.userInfo.memId;
    }
    async getResult() {
        let { data } = await this.$axios.post('/api/activity/h5Activity/anniversary8/calculateResult');
        this.total_count = data.amount;
    }
    //设置数据
    async setData() {
        let { data: firstData, } = await this.$axios.get('/api/activity/h5Activity/anniversary8/getAutoOrders', { params: { limit: 999 } });
        this.firstList = firstData;
        let { data: secondData, } = await this.$axios.get('/api/activity/h5Activity/anniversary8/getClaimedOrders', { params: { limit: 999 } });
        this.secondList = secondData;
    }
    onClickIntro(show = true) {
        this.showIntro = show;
        if (show) {
            uploadEvent.addStatistics({
                event_type: 'Click_PackagingTools_RulePopup',
                p1: this.memId,
            });
        }
    }
    onClickTab(type) {
        this.type = type;
        if (type == 2) {
            this.recordList = this.firstList;
        }
        else {
            this.recordList = this.secondList;
        }
    }
    // ios10 env.login()页面不刷新问题
    async ios10ShadowClick() {
        window.location.reload();
    }
};
default_1 = tslib_1.__decorate([
    Component({
        components: {},
    })
], default_1);
export default default_1;
